import { useState } from "react";
import SearchLightbox from "../searchLightbox";
import {ImageCardProps} from "./types";
import Thumbnail from "./thumbnail";

const ImageCard = ({
  imageSrc,
  thumbnailSrc,
  onSearchClick,
  ImageMetadataComponent,
  caption,
}: ImageCardProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const openModal = () => setIsModalOpen(true);

  const handleSearchOnClick = () => {
    onSearchClick(imageSrc);
    closeModal();
  };

  const handleDetailsClick = async () => {
    openModal();
  };

  return (
    <div className={"flex flex-col items-center justify-center"}>
      <div className="group relative h-56 w-80 overflow-hidden rounded-lg">
        <Thumbnail src={thumbnailSrc} />
        <div className="absolute inset-0 bg-grey-300 bg-opacity-0 opacity-0 transition-opacity duration-300 ease-in-out group-hover:bg-opacity-100 group-hover:opacity-75"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100">
          <button
            className="mb-2 rounded-full bg-blue-100 p-2 text-white hover:bg-blue-700"
            onClick={handleDetailsClick}
          >
            See More Details
          </button>
          <button
            className="rounded-full bg-white p-2 text-blue-100 hover:bg-blue-50"
            onClick={handleSearchOnClick}
          >
            Search on Image
          </button>
        </div>
        <SearchLightbox
          isOpen={isModalOpen}
          closeModal={closeModal}
          imageSrc={imageSrc}
          thumbnailSrc={thumbnailSrc}
          onSearchClick={onSearchClick}
          ImageMetadataComponent={ImageMetadataComponent}
        />
      </div>
      <div className={"w-80 text-center"}>{caption}</div>
    </div>
  );
};

export default ImageCard;
